<template>
  <PbLink
    v-slot="{
      navigate, href, isActive,
    }"
    custom
    :to="to"
  >
    <BaseTab
      class="pb-router-tab"
      :class="{
        'pb-router-tab-active': isActive,
        'pb-router-tab-inactive': !isActive,
      }"
      nopadding
      :state="isActive"
    >
      <BaseButton
        class="pb-router-tab-button"
        :tooltip="title"
        :to="href"
        @click="navigate"
      >
        <slot />
      </BaseButton>
    </BaseTab>
  </PbLink>
</template>

<script setup>
import { toRef } from 'vue'
import BaseTab from '@nicolaudie-group/ng-ui-kit/components/BaseTab/BaseTab.vue'
import BaseButton from '@nicolaudie-group/ng-ui-kit/components/BaseButton/BaseButton.vue'

import PbLink from '@/components/PbLink.vue'

const props = defineProps({
  to: { type: Object, default: () => ({}) },
  title: { type: String, default: '' },
})

const to = toRef(props, 'to')
</script>
